const footerSections = [
  {
    title: "内容板块",
    links: [
      { label: "今日热榜", href: "#hot" },
      { label: "最新吃瓜", href: "#latest" },
      { label: "编辑精选", href: "#editor" },
      { label: "吃瓜讨论区", href: "#community" },
    ],
  },
  {
    title: "热门方向",
    links: [
      { label: "剧集讨论", href: "#topics" },
      { label: "综艺名场面", href: "#topics" },
      { label: "幕后花絮", href: "#topics" },
      { label: "配乐OST", href: "#topics" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "免费说明", href: "#top" },
      { label: "更新节奏", href: "#latest" },
      { label: "社区公约", href: "#community" },
      { label: "内容建议", href: "#community" },
    ],
  },
];

const tagCloud = ["黑料免费", "吃瓜", "看料", "在线浏览", "免费阅读", "热榜", "讨论区"];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-14 md:grid-cols-2 md:px-6 md:py-16 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-fill w-5 h-5 flex items-center justify-center text-base" />
            </span>
            <span className="font-heading text-xl font-bold text-background-50">黑料免费</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            吃瓜看料，在线浏览不花钱。这里把每天的热门讨论整理在一起，免费阅读、随时打开就看，
            不用注册也不用付费，想聊就留下你的看法。
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {tagCloud.map((tag) => (
              <a
                key={tag}
                href="#topics"
                className="whitespace-nowrap rounded-full border border-background-700 px-3 py-1 text-xs text-background-300 transition-colors hover:border-primary-400 hover:text-background-50"
              >
                {tag}
              </a>
            ))}
          </div>
        </div>

        {footerSections.map((section) => (
          <div key={section.title}>
            <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
              {section.title}
            </h4>
            <ul className="mt-4 space-y-3">
              {section.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-background-300 transition-colors hover:text-primary-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-background-800">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-background-400 md:flex-row md:px-6">
          <p>© 2026 黑料免费 · 内容均为演示用途，仅供浏览阅读</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-sm" />
            所有内容免费阅读，不收集个人信息
          </p>
        </div>
      </div>
    </footer>
  );
}